<template>
  <footer class="footer">
    <div class="row align-items-center justify-content-xl-between">
      <div class="col-xl-6">
        <div class="copyright text-center text-xl-left text-muted">
          © 2019 <span class="font-weight-bold ml-1 color-primary">Numisma</span>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style>
.color-primary { color: #5e72e4; }
</style>



// WEBPACK FOOTER //
// src/layouts/Footer.vue